module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.4849d7c4.svg";